const INFO = {
	main: {
		title: "Zhongkang Guo's Website",
		name: "Zhongkang Guo",
		email: "aarongzk@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		twitter: "https://x.com/guozhongkang",
		github: "https://github.com/AaronGZK",
		linkedin: "https://www.linkedin.com/in/zhongkang-guo/",
		instagram: "https://instagram.com/guozhongkang",
	},

	homepage: {
		title: "Hi, I'm Zhongkang Guo",
		description:
			"I'm currently a software engineer at Robinhood.\nI studied at Tsinghua University and the University of Toronto.\nWhen I'm not coding, I love learning languages, running, reading, and watching movies.",
	},

	about: {
		title: "About Me",
		secondary_title: "Programmer\nPodcaster\nPolyglot in progress",
		description:
			`My name is Zhongkang (仲康 in Chinese, pronounced <em>Joong-Kahng</em>).
			My friends also call me Aaron.

			I am currently a software engineer at Robinhood.
			I hold a master's degree from the University of Toronto and a bachelor's degree from Tsinghua University.
			
			Beyond coding, I am deeply curious about learning foreign languages and exploring different cultures, as I believe each language reveals a unique way of thinking and living.
			I am also passionate about movies and literature. My favorite director is Ang Lee, whose films resonate with their depth and humanity, and my favorite writer is Gabriel García Márquez, whose magical realism inspires my imagination and worldview.
			
			I am also a huge fan of Steve Jobs, whose vision, creativity, and relentless pursuit of excellence deeply inspire the way I approach technology, innovation, and philosophy.
			One fun fact: I share the same sun sign and rising sign as Steve Jobs.`,
	},

	copyright: "© 2025 Zhongkang Guo. All Rights Reserved.",
};

export default INFO;
